import { render, staticRenderFns } from "./PayrollSettingLayout.vue?vue&type=template&id=98950576&scoped=true&"
import script from "./PayrollSettingLayout.vue?vue&type=script&lang=js&"
export * from "./PayrollSettingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98950576",
  null
  
)

export default component.exports